import { Options } from 'react-select';
import { NodeTypes } from "reactflow";
import {
  CustomNode,
  EmailNode,
  EndNode,
  LetterNode,
  SMSNode,
  StartNode,
} from "./CustomNodes";

// ModalContext
const UsersFields = [
  "bdtm",
  "bdyear",
  "bdmonth",
  "bdday",
  "mtm",
  "muid",
  "uptm",
  "upuid",
  "mobile",
  "tell",
  "address",
  "codemeli",
  "fullname",
  "fname",
  "lname",
  "refer_from_uid",
  "main_status",
  "usefullHours",
  "email",
  "type",
  "is_admin",
];

const CustomersFields = [
  "firstname",
  "lastname",
  "company_name",
  "address",
  "mobile",
  "tell",
  "mtm",
  "status",
  "corporate",
  "upuid",
  "purchase_count",
  "purchase_volume",
  "man_uid",
  "first_factor_tm",
  "amount_owed",
  "amount_credit",
];

// DetailTab
const StatusOptions: Options<{ label: string; value: string }> = [
  {
    label: "فعال",
    value: "2",
  },
  {
    label: "غیر فعال",
    value: "1",
  },
  {
    label: "متوقف شده",
    value: "0",
  },
];

// StepTab
const AllNodes: NodeTypes = {
  start: StartNode,
  end: EndNode,
  email: EmailNode,
  sms: SMSNode,
  letter: LetterNode,
  custom: CustomNode,
};

const AllNodeTypes = {
  Start: "start",
  End: "end",
  Email: "email",
  SMS: "sms",
  Letter: "letter",
  Custom: "custom",
};

export {
  UsersFields,
  CustomersFields,
  StatusOptions,
  AllNodes,
  AllNodeTypes,
};
